import { render, staticRenderFns } from "./TheAgendamentos.vue?vue&type=template&id=1a789ae1&scoped=true"
import script from "./TheAgendamentos.vue?vue&type=script&lang=js"
export * from "./TheAgendamentos.vue?vue&type=script&lang=js"
import style0 from "./TheAgendamentos.vue?vue&type=style&index=0&id=1a789ae1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a789ae1",
  null
  
)

export default component.exports